import cn from "classnames";
import dynamic from "next/dynamic";
import { useTranslation } from "next-i18next";
import { useEffect, useState, memo } from "react";

import { useStore } from "@hooks/useZustandProvider";

// import { useMousePosition } from "@hooks/useMousePosition";
// import { useIsMounted } from "@hooks/useIsMounted";
// import ContentEditor from "./components/ContentEditor/ContentEditor";
import TextEditor from "./components/TextEditor/TextEditor";
import s from "./Editor.module.scss";

const CKEditor = dynamic(() => import("./components/CKEditor/CKEditor"), {
  ssr: false,
});

// const CKEditorNew = dynamic(() => import("./components/CKEditor/CKEditor_new"), {
//   ssr: false,
// });

const Editor = ({ onlyText = false, field, asSpan = false, ...props }) => {
  const { cms, updateBlockIndex } = useStore();
  // const isMounted = useIsMounted();
  const { isWidgetEditing } = cms.widget;
  const { isWidget } = cms.page;
  const { t } = useTranslation(["common"]);
  // const { isWidget } = useMousePosition();
  const { isEditMode } = cms.uiOptions;
  const [isEditing, setIsEditing] = useState(false);
  const [editorLoaded, setEditorLoaded] = useState(false);
  const [fieldName, fieldValue] = Object.entries(field)[0];

  const handleClick = (e, t) => {
    // TODO: this code must be common for all cases
    try {
      const blockIndex =
        e.target.closest("[data-block-index]")?.dataset?.blockIndex;

      Number.isInteger(Number(blockIndex)) &&
        updateBlockIndex(Number(blockIndex));

      // if (e.currentTarget != e.target) return;

      switch (e.detail) {
        case 1: // click
          setIsEditing(true);
          break;
        case 2: // double click
          break;
        case 3: // triple click
          break;
      }
    } catch (e) {
      console.log("Editor handleClick error", e);
    }
  };

  const handleBlur = () => {
    setIsEditing(false);
  };

  const Editor = onlyText ? TextEditor : CKEditor; // or ContentEditor

  useEffect(() => {
    setEditorLoaded(true);
  }, []);

  // const canEdit = isEditMode && !(!isWidgetEditing && isWidget);

  // return canEdit ? (
  //   <div
  //     className={cn(s.editor, s.editMode)}
  //     data-cursor-notice={isEditing ? "" : "Click to edit text"}
  //   >
  //     {editorLoaded && (
  //       <Editor
  //         canEdit={canEdit}
  //         isEditing={isEditing}
  //         // editorLoaded={editorLoaded}
  //         onBlur={handleBlur}
  //         fieldName={fieldName}
  //         fieldValue={fieldValue}
  //         onClick={handleClick}
  //         {...props}
  //       />
  //     )}
  //   </div>
  // ) : (
  //   <div
  //     className={cn(s.editor, s.editMode)}
  //   >
  //     <Editor
  //       canEdit={canEdit}
  //       isEditing={isEditing}
  //       // editorLoaded={editorLoaded}
  //       onBlur={handleBlur}
  //       fieldName={fieldName}
  //       fieldValue={fieldValue}
  //       onClick={handleClick}
  //       {...props}
  //     />
  //   </div>
  // )

  return isEditMode && !(!isWidgetEditing && isWidget) ? (
    <div
      className={cn(s.editor, s.editMode, onlyText && s.textEditor)}
      data-cursor-notice={isEditing ? "" : "Click to edit text"}
    >
      {editorLoaded && (
        <Editor
          isEditing={isEditing}
          // editorLoaded={editorLoaded}
          onBlur={handleBlur}
          fieldName={fieldName}
          fieldValue={fieldValue}
          onClick={handleClick}
          {...props}
        />
      )}
    </div>
  ) : asSpan ? (
    <span
      {...props}
      dangerouslySetInnerHTML={{ __html: fieldValue }}
      className={cn(s.editor, onlyText ? s.textEditor : "ck ck-content")}
    />
  ) : (
    <div
      {...props}
      dangerouslySetInnerHTML={{ __html: fieldValue }}
      className={cn(s.editor, onlyText ? s.textEditor : "ck ck-content")}
    />
  );
};

export default Editor;
